"use client";

import { c as _c } from "react/compiler-runtime";
import { FiX } from "react-icons/fi";
import { TestIdEnum } from "../../../tests/types";
interface TagProps {
  text: string;
  onClose?: () => void;
}
export const Tag = t0 => {
  const $ = _c(7);
  const {
    text,
    onClose
  } = t0;
  const t1 = `${TestIdEnum.TagPrefix}-${text}`;
  let t2;
  if ($[0] !== onClose || $[1] !== text) {
    t2 = onClose && <button data-testid={`${TestIdEnum.TagClosePrefix}-${text}`} onClick={onClose} className="ml-1.5 flex-shrink-0 p-0.5 rounded-full inline-flex items-center justify-center text-brand-700 dark:text-brand-400 hover:bg-brand-200 dark:hover:bg-brand-800/50 focus:outline-none"><FiX className="w-3 h-3" /></button>;
    $[0] = onClose;
    $[1] = text;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1 || $[4] !== t2 || $[5] !== text) {
    t3 = <span data-testid={t1} className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-brand-100 dark:bg-brand-900/30 text-brand-700 dark:text-brand-400 border border-brand-200 dark:border-brand-800">{text}{t2}</span>;
    $[3] = t1;
    $[4] = t2;
    $[5] = text;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};